import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MenuItemModel} from '../../models/menu-item.model';

@Component({
  selector: 'app-page-menu',
  templateUrl: './page-menu.component.html',
  styleUrls: ['./page-menu.component.scss']
})
export class PageMenuComponent {
  @Input() menuList: MenuItemModel[];
  @Input() activeTab: string;
  @Output() selectTab = new EventEmitter<string>();

  isActive(link: string): string {
    if (this.activeTab) {
      return this.activeTab === link ? 'active' : '';
    }
    return window.location.pathname.includes('/' + link + '/') ? 'active' : '';
  }

  onTabClick(link: string) {
    this.selectTab.emit(link);
  }

  get hasChildren() {
    return this.menuList.some(menu => menu.children && menu.children.length > 0);
  }
}
